class FileHelper {
    constructor() {
        this.mimeTypes = new Map();
        this.initMipMaps();
    }
    initMipMaps() {
        this.mimeTypes.set('bin', 'application/octet-binary');
        this.mimeTypes.set('b3dm', 'application/octet-binary');
        this.mimeTypes.set('glb', 'application/octet-binary');
        this.mimeTypes.set('zip', 'application/octet-binary');
        this.mimeTypes.set('gz', 'application/octet-binary');
        // Image
        this.mimeTypes.set('png', 'image/png');
        this.mimeTypes.set('jpg', 'image/jpeg');
        this.mimeTypes.set('jpeg', 'image/jpeg');
        this.mimeTypes.set('gif', 'image/gif');
        // Text
        this.mimeTypes.set('json', 'application/json');
        this.mimeTypes.set('gltf', 'application/json');
        this.mimeTypes.set('osgjs', 'application/json');
        this.mimeTypes.set('txt', 'text/plain');
        this.mimeTypes.set('glsl', 'text/plain');
    }
    requestResource(uri, options) {
        let extension = this.getExtension(uri);
        let mimetype = this.getMimeType(extension);
        let responseType =
            options && options.responseType ? options.responseType.toLowerCase() : undefined;
        if (responseType) return this.requestFile(uri, options);

        if (mimetype) {
            if (mimetype.match('image')) return this.createImageFromURL(uri);
            else if (mimetype.match('binary')) return this.createArrayBufferFromURL(uri);
            else if (mimetype.match('json')) return this.createJSONFromURL(uri);
            else if (mimetype.match('text')) return this.requestFile(uri);
        }

        return this.requestFile(uri);
    }
    createJSONFromURL(url) {
        return this.requestFile(url).then(function (string) {
            return JSON.parse(string);
        });
    };
    createArrayBufferFromURL(url) {
        return this.requestFile(url, {
            responseType: 'arraybuffer'
        });
    };
    createImageFromURL(url) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onerror = function () {
                reject(img);
            };

            img.onload = function () {
                resolve(img);
            };
            img.src = url;
        });
    };
    getExtension(url) {
        return url.substr(url.lastIndexOf('.') + 1);
    }
    requestFile(urlOrFile, options) {
        return this.requestFileFromURL(urlOrFile, options);
    };
    requestFileFromURL(url, options) {
        return new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();
            req.open('GET', url, true);

            var responseType =
                options && options.responseType ? options.responseType.toLowerCase() : undefined;

            // handle responseType
            if (responseType) req.responseType = responseType;

            if (options && options.progress) {
                req.addEventListener('progress', options.progress, false);
            }

            req.addEventListener('error', reject, false);

            req.addEventListener('load', function () {
                if (req.responseType === 'arraybuffer' || req.responseType === 'blob')
                    resolve(req.response);
                else resolve(req.responseText);
            });

            req.send(null);
        });
    };
    getMimeType(extension) {
        return this.mimeTypes.get(extension);
    };
}
export default FileHelper